import React from 'react';
import { useAuth } from '../../context/AuthContext';
import CompanySelector from '../company/CompanySelector';
import { useNavigate } from 'react-router-dom';

const CompanySelectionWrapper: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { user, selectedCompany, selectCompany } = useAuth();
  const navigate = useNavigate();

  const handleCompanySelect = (company: any) => {
    selectCompany(company);
    // Navigate to main application
    navigate('/', { replace: true });
  };

  // If user is not authenticated, let the auth system handle it
  if (!user) {
    return <>{children}</>;
  }

  // For admin users (admin/superadmin), skip company selection entirely
  if (user.role === 'admin' || user.role === 'superadmin') {
    return <>{children}</>;
  }

  // If user has no companies, show error - let CompanySelector handle this
  if (!user.companies || user.companies.length === 0) {
    return <CompanySelector onCompanySelect={handleCompanySelect} />;
  }

  // If user has exactly one company, auto-select it
  if (user.companies.length === 1 && !selectedCompany) {
    selectCompany(user.companies[0]);
    return <>{children}</>;
  }

  // If user has multiple companies but none selected, show selector
  if (user.companies.length > 1 && !selectedCompany) {
    return <CompanySelector onCompanySelect={handleCompanySelect} />;
  }

  // User has selected a company, show the main app
  return <>{children}</>;
};

export default CompanySelectionWrapper;